const footer = {
    links: [
        {
            icon: 'google',
            link: 'https://google.com',
            text: 'Google'
        }, {
            icon: 'yahoo',
            link: 'https://yahoo.com',
            text: 'Yahoo!'
        }, {
            icon: 'facebook',
            link: 'https://facebook.com',
            text: 'Facebook'
        }
    ],
    copyright: '2021 - PT. Bangun Kapasitas'
}

export default footer
